import { Components, Theme } from '@mui/material/styles'

// Heading/title font, stored on the typography config by createMuiTheme
// (VERA-270). Falls back to the body fontFamily when no title font is set.
const titleFont = (theme: Theme): string =>
  (theme.typography as { titleFontFamily?: string }).titleFontFamily ||
  (theme.typography.fontFamily as string)

const headingColor = (theme: Theme): string =>
  (theme.palette.text as { heading?: string }).heading || theme.palette.text.primary

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  styleOverrides: {
    // Body / paragraph text uses the company Text color (palette.text.primary,
    // VERA-269). Headings are recolored to the primary brand color below.
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily || 'Inter',
    }),
    // Headings: the brand's colour when it has one, else black (VERA-269 / VERA-270).
    // `palette.text.heading` resolves primary_color -> text_color -> #000000, so a
    // white-labelled brand is unaffected while Vera's own default is black rather
    // than the purple accent.
    h1: ({ theme }) => ({ color: headingColor(theme), fontFamily: titleFont(theme) }),
    h2: ({ theme }) => ({ color: headingColor(theme), fontFamily: titleFont(theme) }),
    h3: ({ theme }) => ({ color: headingColor(theme), fontFamily: titleFont(theme) }),
    h4: ({ theme }) => ({ color: headingColor(theme), fontFamily: titleFont(theme) }),
  },
  defaultProps: {
    variant: 'body1',
    variantMapping: {
      body1: 'p',
      body2: 'p',
      // VERA-842: body3 had NO mapping here, so MUI fell back to <span> — an
      // inline box, which silently ignores vertical margins (mb/mt did
      // nothing). Mapping it to <p> makes supporting text behave like the
      // block text it is.
      body3: 'p',
      h1: 'span',
      h2: 'span',
      h3: 'span',
      h4: 'span',
      subtitle1: 'p',
      subtitle2: 'p',
    },
  },
}
